import { createRouter, createWebHashHistory } from 'vue-router';
import layout from '../views/layout/index.vue';
const routes = [
    {
        path: '/',
        name: 'home',
        component: layout,
        redirect: '/tabulation',
        children: [
            {
                path: '/tabulation',
                name: '/tabulation',
                meta: {
                    labe: 'AI表格'
                },
                component: () => import('../views/subview/tabulation.vue')
            }
        ]
    }
];
const router = createRouter({
    history: createWebHashHistory(),
    routes
});
router.beforeEach(async (to, from, next) => {
    var _a, _b, _c, _d;
    console.log(to, from);
    if ((_a = to === null || to === void 0 ? void 0 : to.query) === null || _a === void 0 ? void 0 : _a.token) {
        localStorage.setItem('token', (_b = to === null || to === void 0 ? void 0 : to.query) === null || _b === void 0 ? void 0 : _b.token);
    }
    if ((_c = to === null || to === void 0 ? void 0 : to.query) === null || _c === void 0 ? void 0 : _c.clientId) {
        localStorage.setItem('clientId', (_d = to === null || to === void 0 ? void 0 : to.query) === null || _d === void 0 ? void 0 : _d.clientId);
    }
    return next();
});
export default router;
